{
  "modal": {
    "categoryTierModal": {
      "create": "Skapa",
      "delete": "Radera",
      "descriptionLabel": "Beskrivning",
      "descriptionPlaceholder": "Beskrivning saknas",
      "titleLabel": "Titel",
      "titlePlaceholder": "Ange en titel...",
      "update": "Uppdatera"
    },
    "archiveProject": {
      "title": "Arkivera projekt",
      "confirmDescription": "Är du säker på att du vill arkivera det här projektet inklusive alla dess dokumentversioner?"
    },
    "infoReaders": {
      "description": "Detta är en lista över personer som ska ta del av innehållet i detta dokument och deras status. Endast dokumentägaren kan ändra denna lista.",
      "title": "Läsarinformation"
    },
    "inviteUsers": {
      "name": "Namn",
      "subText": "Användarna kommer att få en inbjudan att läsa och acceptera dokumentet",
      "title": "Bjud in användare"
    },
    "tags": {
      "manageTags": "Hantera taggar",
      "newTag": "Ny tagg",
      "selectTag": "Välj tagg",
      "searchOrCreate": "Sök eller skapa taggar",
      "existingTags": "Befintliga taggar",
      "searchToFindOrCreate": "Sök för att hitta eller skapa taggar"
    },
    "removeLinksWarning": {
      "title": "Länkade dokument kommer att tas bort",
      "description": "Om du ändrar kategori eller nivå på detta dokument kommer alla länkar till andra dokument att försvinna. Är du säker på att du vill fortsätta?",
      "linkedDocumentsRemoval": "Följande länkade dokument kommer att tas bort",
      "proceed": "Fortsätt"
    },
    "editDocumentTitle": {
      "placeholder": "Ange ett nytt namn",
      "duplicateWarning": "Det finns redan ett dokument med namnet"
    },
    "officeDesktop": {
      "trackChangesDisabledTitle": "Spåra ändringar är inte aktiverat.",
      "trackChangesDisabledDescription": "Aktivera spåra ändringar för att säkerställa att ändringar syns.",
      "cancel": "Avbryt"
    }
  }
}
